"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Policy_1 = require("./Policy");
class BlockedCountriesPolicy extends Policy_1.Policy {
    constructor() {
        super(...arguments);
        this.countries = [
            116, 110, 135, 29, 45, 192, 173, 11, 3, 27, 232
        ];
    }
    meets(criteria) {
        return this.countries.includes(criteria.countryId);
    }
}
exports.default = new BlockedCountriesPolicy();
